// extracted by mini-css-extract-plugin
export default {"applePayButton":"G7d2ee3","applePayButtonText":"G9319e5","applePayButtonLogo":"G9d72d2"};